import React from "react";
import { Link } from "react-router-dom";
import Experience from "../domestic-services/experiencecount";
import Testimonial from "../components/testimonial";
import bggVideo from "../components/videos/bg4.mp4";

const services = [
  {
    title: "FBA Shipment Creation",
    desc: "We create and manage FBA shipments through Seller Central, ensuring correct product mapping, quantities, and warehouse allocation as per Amazon guidelines.",
  },
  {
    title: "APOB Registration Support",
    desc: "We assist sellers in completing the APOB (Additional Place of Business) process required for smooth FBA operations and compliance.",
  },
  {
    title: "Pickup Scheduling & Coordination",
    desc: "We handle pickup scheduling with Amazon logistics and ensure timely dispatch without delays.",
  },
  {
    title: "Shipment Tracking & Monitoring",
    desc: "We track shipments from dispatch to warehouse delivery and provide regular updates.",
  },
  {
    title: "Inventory Live Monitoring",
    desc: "We monitor whether your inventory is received and goes live on Amazon, and resolve delays if any.",
  },
];

const processSteps = [
  {
    title: "Dedicated Account Manager",
    desc: "Each seller gets a dedicated account manager for personalized and consistent support.",
  },
  {
    title: "Regular Account Audits",
    desc: "We conduct periodic audits to ensure listing quality, accuracy, and compliance.",
  },
  {
    title: "Proactive Issue Resolution",
    desc: "We monitor alerts and resolve issues quickly following Amazon guidelines.",
  },
  {
    title: "Transparent Communication",
    desc: "We provide clear updates, reports, and recommendations.",
  },
  {
    title: "Data-Driven Improvement",
    desc: "We use performance data to optimize and improve account stability.",
  },
];

const Events = () => {
  return (
    <>
      {/* HERO SECTION */}
      <div className="color-slider-section text-center">
        <video
          className="bg-video"
          autoPlay
          muted
          loop
          playsInline
          preload="none"
        >
          <source src={bggVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="color-slider-content">
          <h1 className="p-2">
            Amazon FBA Shipment Management Services in India
          </h1>
          <p>
            We manage the complete FBA shipment process—from creation to
            inventory going live—ensuring accuracy, compliance, and timely
            execution.
          </p>

          <div className="mt-4 d-flex gap-3 flex-wrap justify-content-center">
            <a href="tel:+918527203697" className="btn btn-warning px-4 py-2">
              Call Us +91 85272 03697
            </a>

            <Link
              to="/Contact"
              className="btn btn-outline-light px-4 py-2"
            >
              Get Free Consultation
            </Link>
          </div>
        </div>
      </div>

      {/* SERVICES */}
      <div className="bg">
       <div className="container-fluid px-0">
          <h2 className="h33 text-center">
            FBA Shipment & Operations Support Services
          </h2>

          <p style={{ color: "white" }} className="text-center">
            We provide complete end-to-end support for Amazon FBA shipment
            operations, ensuring smooth processing and avoiding delays, errors,
            and account issues.
          </p>

          <div className="row g-3">
            {services.map((item, index) => (
              <div key={index} className="col-12 col-md-4 col-lg-3">
                <div className="service-box">
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}

            {/* ISSUE HANDLING */}
            <div className="col-12 col-md-4 col-lg-3">
              <div className="service-box">
                <h5>Issue Resolution & Removal Handling</h5>
                <p className="mb-2">
                  We proactively manage and resolve all FBA shipment-related
                  issues to ensure smooth operations:
                </p>
               <ul className="ps-3 mb-0">
  <li>✔ Missing units reconciliation</li>
  <li>✔ Delayed check-in follow-ups</li>
  <li>✔ Shipment discrepancy resolution</li>
  <li>✔ Removal order handling & coordination</li>
</ul>
              </div>
            </div>

            {/* WHY CHOOSE US */}
            <div className="col-12 col-md-4 col-lg-3">
              <div className="service-box">
                <h5>Why Sellers Trust Us</h5>

                <p className="mt-2">
                  Trusted by 100+ sellers across India for Amazon account
                  management and FBA operations support.
                </p>

                <ul className="ps-3 mb-2">
                  <li>✔ 5+ years of e-commerce experience</li>
                  <li>✔ Dedicated team of 15+ experts</li>
                  <li>✔ Amazon-trained professionals</li>
                  <li>✔ End-to-end seller support</li>
                </ul>

                <p className="text-success mt-2">
                  ✔ Structured support that helps maintain account health and
                  avoid operational issues
                </p>

              

               
              </div>
            </div>
          </div>

          {/* IMPORTANT NOTE */}
          <div className="h35 mt-4">
            <h3>Important Note (For Compliance)</h3>
            <p style={{ fontStyle: "italic" }}>
              We provide operational and management support for FBA shipments. We
              do not perform physical packaging, labeling, or warehouse
              services.
            </p>
            <p className="text-warning small mt-2">
              ⚠️ We are an independent service provider and not directly
              affiliated with Amazon.
            </p>
          </div>

          {/* PROCESS */}
          <div className="h34 text-center mt-5">
            <h2>How We Work – Our FBA Management Process</h2>
            <p>
              We follow a structured, process-driven approach focused on
              compliance, efficiency, and transparency.
            </p>
          </div>

          

          {/* WHO WE SERVE */}
          <div className="white-section text-center mt-5">
            <div className="row justify-content-center g-4">
              <div className="col-md-6">
                <h3>Who We Serve</h3>
                <ul className="text-start d-inline-block">
                  <li>New Amazon sellers</li>
                  <li>Existing sellers optimizing operations</li>
                  <li>Domestic Amazon India sellers</li>
                </ul>
              </div>

              <div className="col-md-6">
                <h3>Why Choose E Seller Support</h3>
                <ul className="text-start d-inline-block">
                  <li>Dedicated account manager</li>
                  <li>Compliance-first support</li>
                  <li>Transparent communication</li>
                  <li>Account health monitoring</li>
                </ul>

                <p className="mt-3 text-warning">
                  ⚠️ We do not guarantee sales, approvals, or specific outcomes.
                </p>
              </div>
            </div>
          </div>

          {/* COMPONENTS */}
          <Experience />
          <Testimonial />

          {/* DISCLAIMER */}
          <div className="h35 mt-4">
            <h3>Disclaimer</h3>
            <p style={{ fontStyle: "italic" }}>
              All services are provided in accordance with Amazon Seller Central
              policies. We do not offer any services that violate Amazon terms.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Events;